import * as PIXI from "pixi.js";
import { GameAssets } from "../util/GameAssets";

// Define an enum for the states
export enum SpinButtonState {
    SPIN = "SPIN",
    AUTOPLAY = "AUTOPLAY",
    PASSIVE = "PASSIVE",
}

export class SpinButton extends PIXI.Container {
    private sprite: PIXI.Sprite;
    public get Sprite() {
        return this.sprite;
    }
    private autoplayLabel: PIXI.Text;
    private currentState: SpinButtonState = SpinButtonState.PASSIVE;
    private autoplayAmount: number = 0;

    constructor() {
        super();
        this.autoplayLabel = new PIXI.Text({
            text: "5",
            style: {
                fill: "#ffffff",
                fontSize: 30,
                fontWeight: "bold",
                align: "center",
            },
        });
        this.autoplayLabel.anchor.set(0.5);
        this.autoplayLabel.position.set(0, 0); // Center in the button
        this.autoplayLabel.visible = false;

        this.sprite = new PIXI.Sprite(GameAssets.textures.uiAtlas.textures["spinButton.webp"]);
        this.sprite.anchor.set(0.5);
        this.sprite.position.set(0, 0);
        this.sprite.interactive = true;
        this.sprite.on("pointerup", this._handleClick, this);

        this.addChild(this.sprite);
        this.addChild(this.autoplayLabel);
    }

    getAutoplay() {
        return this.autoplayAmount;
    }

    public resetButton() {
        if (this.currentState === SpinButtonState.AUTOPLAY) {
            this._decrementAutoplay();
            if (this.autoplayAmount === 0) {
                this.autoplayLabel.visible = false;
                this._changeState(SpinButtonState.SPIN);
            } else {
                this.emit("spin");
            }
        } else {
            this._changeState(SpinButtonState.SPIN);
        }
    }

    onClick() {
        this._handleClick();
    }

    setPassive() {
        this._changeState(SpinButtonState.PASSIVE);
    }

    setAutoplay(autoplayAmount: number) {
        this.autoplayAmount = autoplayAmount;
        if (this.autoplayAmount !== 0) {
            // this.sprite.texture = GameAssets.textures.stopButton;
            this.autoplayLabel.visible = true;
            this.autoplayLabel.style.fill = 0xffffff;
            let text = this.autoplayAmount.toString();
            if (autoplayAmount === -1) {
                text = "\u221E";
            }
            this.autoplayLabel.text = text;
        } else {
            // this.sprite.texture = GameAssets.textures.spinButton;
            this.autoplayLabel.visible = false;
        }
    }

    private _handleClick() {
        switch (this.currentState) {
            case SpinButtonState.PASSIVE:
                break;
            case SpinButtonState.SPIN:
                if (this.autoplayAmount !== 0) {
                    this.emit("autoplayStart");
                    this._changeState(SpinButtonState.AUTOPLAY);
                } else {
                    this.emit("spin");
                    this._changeState(SpinButtonState.PASSIVE);
                }
                break;
            case SpinButtonState.AUTOPLAY:
                this.autoplayAmount = 0;
                this.autoplayLabel.visible = false;
                this._changeState(SpinButtonState.PASSIVE);
                this.emit("autoplayStop");
                break;
        }
    }

    public resize(data: any) { }

    private _onSpin() {
        this.sprite.texture = GameAssets.textures.uiAtlas.textures["spinButton.webp"];
        this.sprite.alpha = 1;
        this.sprite.interactive = true;
        this.sprite.visible = true;
    }

    private _onAutoplay() {
        this.sprite.texture = GameAssets.textures.uiAtlas.textures["stopButton.webp"];
        this.autoplayLabel.style.fill = 0xff8531;
        this.sprite.interactive = true;
        this._decrementAutoplay();
        this.emit("spin");
    }

    private _decrementAutoplay() {
        if (this.autoplayAmount > 0) {
            this.autoplayAmount--;
            this.autoplayLabel.text = this.autoplayAmount.toString();
        }
    }

    private _onPassive() {
        this.sprite.visible = false;
        this.sprite.interactive = false;
    }

    private _changeState(newState: SpinButtonState) {
        if (this.currentState === newState) return; // No change if the same state

        // Enter logic for the new state
        this.currentState = newState;
        switch (this.currentState) {
            case SpinButtonState.PASSIVE:
                this._onPassive();
                break;
            case SpinButtonState.SPIN:
                this._onSpin();
                break;
            case SpinButtonState.AUTOPLAY:
                this._onAutoplay();
                break;
        }
    }
}
